import LoginPage from "../auth/components/login";
import register from "../auth/components/register";
import ForgotPage from "../auth/components/forgotPassword";
import resetPassword from "../auth/components/resetPassword";
import loginOtp from "../auth/components/otpLogin";
import authLayout from "./views/authLayout";

// import table from '../auth/components/table';
// import RegistrationPage from '@/views/RegistrationPage.vue';

const authRoutes = [
  {
    path: "",
    component: authLayout,
    children: [
      {
        path: "",
        name: "signIn",
        component: LoginPage,
      },
      {
        path: "/forgot",
        name: "forgot",
        component: ForgotPage,
      },
      {
        path: "/register",
        name: "register",
        component: register,
      },
      {
        path: "/reset-password/:token",
        name: "resetPassword",
        component: resetPassword,
      },

      {
        path: "/otp-code",
        name: "loginOtp",
        component: loginOtp,
      },
    ],
  },
];

export default authRoutes;
